import type { Testimonial } from '@/types/content';

export const testimonials: Testimonial[] = [
  {
    name: '小满不赶路',
    role: '内容运营 · 每晚必刷',
    quote:
      '最舒服的一点是按分类整理。以前刷爆料像在黑屋子里找东西，现在直接进感兴趣的合集，十分钟就能把一件事的来龙去脉看完。',
    initial: '满',
  },
  {
    name: '阿栗同学',
    role: '大学生 · 追剧党',
    quote:
      '娱乐圈那个分区我几乎每篇都看，讲宣发节奏和剧集排期的部分特别清楚，看完再去刷评论区，感觉自己终于不是在被带着跑了。',
    initial: '栗',
  },
  {
    name: '老周聊内容',
    role: '短视频编导',
    quote:
      '行业秘闻分区对我帮助挺大，选品、算法更替这些话题讲得比较克制，没有夸张的标题，但信息密度够，适合做选题参考。',
    initial: '周',
  },
  {
    name: '菜市场第一排',
    role: '吃瓜老观众',
    quote:
      '难得的是有分寸。素人那个分区没有把普通人当乐子，看着不别扭，这点我愿意一直用下去。',
    initial: '菜',
  },
];